import { useMutation } from 'react-query';
import { axiosInstance } from "../../config/axios";

export const useAddResponseCodeWithExcelMutation = () => {
  return useMutation((file: File) => {
    const formData = new FormData();
    formData.append('files', file);

    return axiosInstance.post('/ResponseCode/AddResponseCodeWithExcel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  });
};